export class PayloadContent {
  /**
   * The payload type. The payload types are described in Payload-Specific Property Keys.
   */
  public payloadType: string;

  /**
   * The version number of the individual payload.
   * A profile can consist of payloads with different version numbers.
   * For example, changes to the VPN software in iOS might introduce a new payload version to support additional features,
   *  but Mail payload versions would not necessarily change in the same release.
   */
  public payloadVersion: number;

  /**
   * A reverse-DNS-style identifier for the specific payload.
   * It is usually the same identifier as the root-level PayloadIdentifier value with an additional component appended.
   */
  public payloadIdentifier: string;

  /**
   * A globally unique identifier for the payload.
   * The actual content is unimportant, but it must be globally unique. In macOS, you can use uuidgen to generate reasonable UUIDs.
   */
  public payloadUUID: string;

  /**
   * A human-readable name for the profile payload. This name is displayed on the Detail screen. It does not have to be unique.
   */
  public payloadDisplayName: string;

  /**
   * Optional. A human-readable description of this payload. This description is shown on the Detail screen.
   */
  public payloadDescription?: string;

  /**
   * Optional. A human-readable string containing the name of the organization that provided the profile.
   * The payload organization for a payload need not match the payload organization in the enclosing profile.
   */
  public payloadOrganization?: string;
}
